import React from 'react';

const MapVisualizationSettings = ({ 
    headers, 
    visualSettings, 
    onVisualizationChange, 
    onColorRuleChange,
    getUniqueValues,
    availableColors 
}) => {
    // Function to convert color name to hex
    const getColorHex = (colorName) => {
        const colorMap = {
            blue: '#3B82F6',
            red: '#EF4444',
            green: '#10B981',
            yellow: '#F59E0B',
            purple: '#8B5CF6',
            pink: '#EC4899',
            orange: '#F97316',
            teal: '#14B8A6',
            cyan: '#06B6D4',
            lime: '#84CC16'
        };
        return colorMap[colorName] || colorName;
    };

    // Function to convert hex to closest color name
    const getColorName = (hex) => {
        const colorMap = {
            '#3B82F6': 'blue',
            '#EF4444': 'red',
            '#10B981': 'green',
            '#F59E0B': 'yellow',
            '#8B5CF6': 'purple',
            '#EC4899': 'pink',
            '#F97316': 'orange',
            '#14B8A6': 'teal',
            '#06B6D4': 'cyan',
            '#84CC16': 'lime'
        };
        return colorMap[hex] || hex;
    };

    return (
        <div className="mb-4 p-4 border rounded">
            <h2 className="text-lg font-bold mb-3">Visualization Settings</h2>
            
            {/* Size By Control */}
            <div className="mb-3">
                <label className="block text-sm font-medium mb-1">
                    Size markers by:
                </label>
                <select 
                    className="border rounded p-2"
                    value={visualSettings.sizeBy}
                    onChange={(e) => onVisualizationChange('sizeBy', e.target.value)}
                >
                    <option value="">None</option>
                    {headers.map((header, index) => (
                        <option key={index} value={header}>
                            {header}
                        </option>
                    ))}
                </select>
            </div>

            {/* Color By Control */}
            <div className="mb-3">
                <label className="block text-sm font-medium mb-1">
                    Color markers by:
                </label>
                <select 
                    className="border rounded p-2"
                    value={visualSettings.colorBy}
                    onChange={(e) => onVisualizationChange('colorBy', e.target.value)}
                >
                    <option value="">None</option>
                    {headers.map((header, index) => (
                        <option key={index} value={header}>
                            {header}
                        </option>
                    ))}
                </select>
            </div>

            {/* Color Rules */}
            {visualSettings.colorBy && (
                <div className="mt-2">
                    <h3 className="text-sm font-medium mb-2">Color Rules:</h3>
                    {getUniqueValues(visualSettings.colorBy).map((value, index) => (
                        <div key={index} className="flex items-center mb-1">
                            <span className="mr-2">{value}:</span>
                            <div className="relative flex items-center">
                                <div 
                                    className="w-6 h-6 border border-gray-300 rounded cursor-pointer"
                                    style={{ 
                                        backgroundColor: getColorHex(visualSettings.colorRules[value] || 'blue'),
                                    }}
                                >
                                    <input
                                        type="color"
                                        value={getColorHex(visualSettings.colorRules[value] || 'blue')}
                                        onChange={(e) => onColorRuleChange(value, getColorName(e.target.value))}
                                        className="absolute inset-0 opacity-0 w-6 h-6 cursor-pointer"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MapVisualizationSettings;
